import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./AuthContext";
import "../stili/NavbarHome.css";

export default function NavbarHome() {
  const { accessToken, logout } = useAuth();

  return (
    <nav className="navbar" role="navigation" aria-label="main navigation">
      <div className="navbar-left">
        <div className="logo" aria-label="Nome Società">
          Asd Monterotondo 1935
        </div>
      </div>

      <div className="navbar-right">
        {accessToken ? (
          <>
            <Link to="/gestionale" className="nav-link">
              Gestionale
            </Link>

            <button
              onClick={logout}
              className="nav-button"
              aria-label="Logout"
              type="button"
            >
              Logout
            </button>
          </>
        ) : (
          <Link to="/login" className="nav-link nav-link-login">
            Login
          </Link>
        )}
      </div>
    </nav>
  );
}